/* global Vue, VueRouter, LOYALTY_API, LOYALTY_AWARDS */

import { setErrorAndStopLoading, startLoading, stopLoading } from '../../apps/components/Notifications'
import AwardCardList from '../components/AwardCardList'
import SectionHeading from '../components/SectionHeading'
import { AuthService, fetchWithTokenAsync } from '../../AuthService'

export default {
  name: 'Awards',
  components: { AwardCardList, SectionHeading },
  template: `
<div class="loyalty-awards container section-margin-bottom no-padding-sm-down">

  <h3 v-show="$router.currentRoute.value.name === 'RecommendedAwards'">{{ $t('awards.recommendedTitle') }}</h3>

  <AwardCardList v-if="awards.length" :awards="awards" :useFilters="useFilters" />
  <div v-else class="container grid">
    <div class="col-12 col-md-10 offset-md-1 col-xl-8 offset-xl-2">
      <div class="loyalty-awards__banner">
        <p>{{ $t('awards.noReservations') }}</p>
        <a class="button button--maistar" href="#/check-rates">{{ $t('checkRates.checkRatesButton') }}</a>
      </div>
    </div>
  </div>
</div>
  `,
  props: {
    loyaltyId: Number,
  },
  setup (props, { emit }) {
    const allAwards = Vue.ref([])
    const router = VueRouter.useRouter()
    const useFilters = Vue.ref(true)

    const awards = Vue.computed(() => {
      if (router.currentRoute.value.name === 'RecommendedAwards') {
        useFilters.value = false
        return allAwards.value.filter(a => a.recomended === 1)
      }
      useFilters.value = true
      return allAwards.value
    })

    const { loyaltyId } = Vue.toRefs(props)

    Vue.watch(loyaltyId, async () => {
      try {
        startLoading('awards-watch')
        const responseAwards = await fetchWithTokenAsync(`${LOYALTY_API}/api/v1/getawards/1/1`, AuthService.accessToken, 'GET')
        if (!responseAwards?.awards) {
          throw Error('awards')
        }
        const beternaAwards = responseAwards.awards
        allAwards.value = beternaAwards.filter(ba => {
          return LOYALTY_AWARDS.some(ca => {
            if (ca.beternaid === ba.prizeID.toString()) {
              Object.assign(ba, ca)
              return true
            }
            return false
          })
        })
        stopLoading('awards-watch')
      } catch (e) {
        setErrorAndStopLoading(e)
      }
    }, { immediate: true })

    return {
      awards,
      useFilters,
    }
  },
}
